import React from "react";
import { ClipboardListIcon, ClockIcon, SearchIcon, BoxIcon } from "lucide-react";
import { Accent, SectionHeading } from "./SectionHeading";
import { painPoints } from "../../data/content";
const icons = [ClockIcon, BoxIcon, SearchIcon, ClipboardListIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-142" data-mp="3m15o7wapfao9">
      <div className="mx-auto max-w-5xl" data-id="element-143" data-mp="njjpu3meenas">
        <SectionHeading id="pain-heading" title={<>
              Vous savez enseigner les nails. <Accent data-id="element-145" data-mp="ikfg9bvkanjx">Mais devez-vous vraiment tout préparer vous-même ?</Accent>
            </>} data-id="element-144" data-mp="ni8jbw1kj1fz" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-146" data-mp="drmackocx969">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6" data-id="element-147" data-mp="16a1d3sogoqor" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-white" data-id="element-148" data-mp="11i9jtadx86ux">
                  <Icon className="h-5 w-5 text-brand-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-149" data-mp="3bcznm8c2cihq" />
                </span>
                <span data-id="element-150" data-mp="3gbszjwbpc1fs">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-151" data-mp="3gef4do77k2ub">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-152" data-mp="36kycwqujmztt">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-153" data-mp="2wpeik8vmo976">
          Vous n’avez pas besoin de travailler plus. <Accent data-id="element-154" data-mp="2nmvitxn52cp5">Vous avez besoin d’un système sur lequel vous appuyer.</Accent>
        </p>
      </div>
    </section>;
}